












































































































































































































































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import Header from "@/components/header/MLoginHeader.vue";
import Footer from "@/components/Footer.vue";
import UsersApi from "@/services/UsersApi";
import { NewPreUserByAdmin, NewSpecialUserByAdmin, UpdateUser, User } from "@/api/lab-base-api-client";
import CheckAdminLogin from "@/utils/CheckAdminLogin";
import CTooltip from "@/components/CTooltip.vue";
import TooltipModule from "@/store/tooltip";
import { sortCreatedAt } from "@/utils/Util";
import { ValidationObserver } from "vee-validate";
import dayjs from "dayjs";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    Footer,
    CTooltip,
  },
})
export default class MUserList extends CheckAdminLogin {
  // 削除済みユーザー表示スイッチ初期値
  private includeDelete = false;

  // プレミアユーザー表示スイッチ初期値
  private premiumSwitch = false;

  // tableの検索初期値
  private search = "";

  // tableのheader設定配列
  private headers = [
    {
      text: "user name",
      align: "start",
      sortable: false,
      value: "name",
    },
    {
      text: "mail address",
      value: "email",
    },
    {
      text: "status",
      value: "status",
    },
    { text: "", value: "actions", sortable: false },
  ];

  // エラーモーダル表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  // 削除・編集の対象userのuuid
  private uuid = "";

  // tableのデータ配列
  private listItems: User[] = [];

  private isInviteDialog = false;

  // 特別招待ダイアログの表示
  private isSpecialInviteDialog = false;

  private createItems: NewPreUserByAdmin = { email: "", confirmEmail: "" };

  private defaultCreateItems: NewPreUserByAdmin = { email: "", confirmEmail: "" };

  private form: {} = {
    email: "",
    confirmEmail: "",
  };

  private isResendDialog = false;

  private createResendItems: NewPreUserByAdmin = { email: "", confirmEmail: "" };

  private defaultResendItems: NewPreUserByAdmin = { email: "", confirmEmail: "" };

  private isEditDialog = false;

  private editItems: UpdateUser = {
    email: "",
    detail: {
      uuid: "",
      fullName: "",
      birthday: "",
      prefecture: "",
      city: "",
    },
  };

  private defaultEditItems: UpdateUser = {
    email: "",
    detail: {
      uuid: "",
      fullName: "",
      birthday: "",
      prefecture: "",
      city: "",
    },
  };

  private dialogDelete = false;

  // 削除ダイアログの確認checkboxの初期値
  private checkbox = false;

  // 特別招待ユーザー入力フォーム
  private specialInviteForm: NewSpecialUserByAdmin = {
    name: "",
    email: "",
    confirmEmail: "",
    detail: {
      uuid: "",
      fullName: "",
      birthday: "",
      prefecture: "",
      city: "",
    },
  };

  // デフォルト特別招待ユーザー入力フォーム
  private defaultSpecialInviteForm: NewSpecialUserByAdmin = {
    name: "",
    email: "",
    confirmEmail: "",
    detail: {
      uuid: "",
      fullName: "",
      birthday: "",
      prefecture: "",
      city: "",
    },
  };

  // 入力、表示の日付
  private inputDate = "";

  private activePicker: string | null = null;

  private menu = false;

  // ページ読み込み時に実行
  private async mounted() {
    await this.fetchList();
    this.listItems.sort(sortCreatedAt);
  }

  // 削除済みユーザー表示スイッチ切り替え時に実行
  private async onIncludeDelete() {
    this.premiumSwitch = false;
    if (this.includeDelete) {
      const users = await UsersApi.instance.getUsers(undefined, undefined, undefined, undefined, this.includeDelete);

      this.listItems = users.data.data.items;
    } else {
      this.fetchList();
    }
    this.listItems.sort(sortCreatedAt);
  }

  // プレミアユーザー表示スイッチ切り替え時に実行
  private async onPremium() {
    this.includeDelete = false;
    await this.fetchList();

    if (this.premiumSwitch) {
      this.listItems = this.listItems.filter(item => {
        return item.paidFlag;
      });
    }
  }

  // user一覧の取得
  private async fetchList() {
    const users = await UsersApi.instance.getUsers();
    this.listItems = users.data.data.items;
  }

  // 「Invite」クリックで実行
  private onNewItem() {
    this.isInviteDialog = true;
  }

  // 招待ユーザー登録ダイアログ「save」で実行、招待ユーザーを登録
  private async createSubmit() {
    try {
      const UsersRes = await UsersApi.instance.createPreUserByAdmin(this.createItems);
      if (!UsersRes?.data?.data?.user) {
        return;
      }
      this.closeCreate();
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
    this.includeDelete = false;
    this.fetchList();
  }

  // 招待ユーザー登録ダイアログを閉じる
  private closeCreate() {
    this.isInviteDialog = false;
    this.createItems = { email: "", confirmEmail: "" };
    TooltipModule.commitIsShow(false);
    this.resetValidation();
  }

  // 「resend email」クリックで実行
  private onResendToken() {
    this.isResendDialog = true;
  }

  // 招待メールを再送信ダイアログ「send」クリックで実行
  private async resendSubmit() {
    try {
      await this.userSendToken();
      this.closeResendDialog();
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // 招待メールを再送信
  private async userSendToken() {
    await UsersApi.instance.sendUserRegisterToken(this.createResendItems);
  }

  // 招待再送信ダイアログを閉じる
  private closeResendDialog() {
    this.isResendDialog = false;
    this.createResendItems = { email: "", confirmEmail: "" };
    TooltipModule.commitIsShow(false);
    this.resetValidation();
  }

  // 編集アイコンclickで実行
  private async onEditItem(uuid: string) {
    this.isEditDialog = true;
    this.uuid = uuid;
    try {
      const user = await UsersApi.instance.getUserByUuid(this.uuid);

      this.editItems.email = user.data.data.user.email;
      if (this.editItems.detail) {
        this.editItems.detail.uuid = user.data.data.user.userDetail.uuid;
        this.editItems.detail.fullName = user.data.data.user.userDetail.fullName;
        this.editItems.detail.birthday = user.data.data.user.userDetail.birthday;
        this.editItems.detail.prefecture = user.data.data.user.userDetail.prefecture;
        this.editItems.detail.city = user.data.data.user.userDetail.city;
      }
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // 編集ダイアログの「save」クリックで実行
  private async saveEdit() {
    try {
      await UsersApi.instance.updateUserByUuid(this.uuid, this.editItems);
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
    this.closeEdit();
    this.fetchList();
  }

  // 編集ダイアログを閉じる
  private closeEdit() {
    this.isEditDialog = false;
    this.editItems = { ...this.defaultEditItems };
    this.uuid = "";
  }

  // 削除アイコンclickで実行
  private async onDeleteItem(uuid: string) {
    this.dialogDelete = true;
    this.uuid = uuid;
  }

  // 削除ダイアログの「ok」クリックで実行
  private async deleteItem() {
    try {
      await UsersApi.instance.deleteUserByUuid(this.uuid);
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
    this.closeDelete();
    await this.fetchList();
  }

  // 削除ダイアログを閉じる
  private closeDelete() {
    this.dialogDelete = false;
    this.uuid = "";
    this.checkbox = false;
  }

  // clickRow
  private clickRow(item: { uuid: string; registered: boolean }) {
    if (item.registered) {
      this.$router.push({ name: "MUserListDetail", params: { uuid: item.uuid } });
    }
  }

  // 特別ユーザー招待
  private async submitSpecialUserInvite() {
    // 日付変換
    if (this.specialInviteForm.detail) {
      this.specialInviteForm.detail.birthday = dayjs(this.inputDate).format("YYYY-MM-DD");
    }
    try {
      this.specialInviteForm.detail.fullName = this.specialInviteForm.name;
      await UsersApi.instance.createSpecialUserByAdmin(this.specialInviteForm);
      this.closeSpecialUserInviteDialog();
      await this.fetchList();
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // date-pickerをchangeしたときに実行
  private changeDatePicker(date: Date) {
    this.inputDate = dayjs(date).format("YYYYMMDD");
    this.menu = false;
  }

  @Watch("menu")
  private async clickCalender() {
    setTimeout(() => {
      this.activePicker = "YEAR";
    });
  }

  // 特別ユーザー招待ダイアログを閉じる
  private closeSpecialUserInviteDialog() {
    this.isSpecialInviteDialog = false;
    this.specialInviteForm = { ...this.defaultSpecialInviteForm };
    this.resetValidation();
  }

  // バリデーションリセット
  private resetValidation() {
    if (!this.$refs.observer) {
      return;
    }
    (this.$refs.observer as InstanceType<typeof ValidationObserver>).reset();
  }
}
